module.exports = __webpack_public_path__ + "static/AdelleSans-Regular-5b4f36dcb67fe4a57f358817e46e6578.woff";